import * as React from 'react'
import toast from "react-hot-toast";
import { ToastOptions } from "react-hot-toast/dist/core/types";
import ToastMessage from './ToastMessage';

export { ToastMessage };

export const defaultOptionsToast: ToastOptions = {

    duration: 4000,
    position: 'top-right',
    // Styling
    style: {},
    className: '',
    // Custom Icon
    // Change colors of success/error/loading icon
    // iconTheme: {
    //     primary: '#000',
    //     secondary: '#fff',
    // },


}


export const toastShowMessage = (message: string, isSuccess: boolean = true) => {
    if (isSuccess) {
        toast.success((t) => (
            <ToastMessage message={`${message}`} t={t} />
        ), defaultOptionsToast);
    } else {
        toast.error((t) => (
            <ToastMessage message={`${message}`} t={t} />
        ), defaultOptionsToast);
    }

}